import './polyfills';
import React from 'react';
import { hydrate } from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { ensureReady, After } from '@jaredpalmer/after';
import * as Sentry from '@sentry/browser';
import { createBrowserHistory } from 'history';
import moment from 'moment';
import 'moment/locale/nl';
import 'moment/locale/fr';
import 'moment/locale/de';
import configureStore from './redux/store';
import routes from './routes';
// This needs to defined in client.jsx to make sure it gets bundled in assets.json
// and so can be loaded directly on page load.
import './stylesheets/web/main.scss';

moment.locale('nl');

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://a716fd896c4a4beda9aad8bad27881c6@sentry.io/1477099',
    environment: process.env.RAZZLE_ENV,
    whitelistUrls: [
      // /((www|staging|testing)\.)?beeksebergen\.nl/,
      /d33b12c77av9bg\.cloudfront\.net/,
      /d1gfv2rhwqork\.cloudfront\.net/,
    ]
  });
}

const history = createBrowserHistory();
const store = configureStore(window.__PRELOADED_STATE__);

history.listen((location) => {
  if (typeof window !== 'undefined' && window.ga) {
    window.ga('set', 'page', location.pathname + location.search);
    window.ga('send', 'pageview');
  }
});

ensureReady(routes).then(data => hydrate(
  <Router history={history}>
    <Provider store={store}>
      <After data={data} routes={routes} />
    </Provider>
  </Router>,
  document.getElementById('root')
));

if (module.hot) {
  module.hot.accept();
}
